import {ReactNode} from 'react';

import {ConversationsUIFeatureFlagsProvider} from '../../StripeAssistant/providers/ConversationsUIFlagsProvider';
import {
  useThreadsAudience,
  useThreadsEntryPoint,
  useThreadsFlags,
  useThreadsViewMode,
} from '../app/hooks';

export function ThreadsConversationsUIFlagsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const featureFlags = useThreadsFlags();
  const audience = useThreadsAudience();
  const entryPoint = useThreadsEntryPoint();
  const viewMode = useThreadsViewMode();

  return (
    <ConversationsUIFeatureFlagsProvider
      featureFlags={featureFlags}
      audience={audience}
      entryPoint={entryPoint}
      viewMode={viewMode}
    >
      {children}
    </ConversationsUIFeatureFlagsProvider>
  );
}
